import { useContext } from 'react';
import { ModalContext } from '../contexts';
import type { ModalContextProps } from '../contexts';

export default (): ModalContextProps => useContext(ModalContext);
